import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { TriangleAlert } from 'lucide-react'
import { EmptyState } from '@/components/EmptyState'

export function RouteErrorPage() {
  const error = useRouteError()
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong.'
  const stack =
    !isRouteErrorResponse(error) && error instanceof Error ? error.stack : null

  // Why: log the route-level error to the console so the dev tools
  // capture the full stack even if the user closes the page. This is
  // the difference between "Cannot read properties of undefined" being
  // diagnosable vs. a dead-end one-liner.
  // eslint-disable-next-line no-console
  console.error('[RouteErrorPage]', error)

  // Stack trace is only rendered in dev / staging - not in production -
  // so end users still get the friendly empty state.
  const showStack = stack && !import.meta.env.PROD

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-3xl">
        <EmptyState icon={TriangleAlert} title="Unexpected error" description={message} />
        {showStack ? (
          <pre className="mt-6 max-h-[40vh] overflow-auto rounded-md border border-border bg-muted/40 p-3 text-left text-[11px] leading-snug text-muted-foreground">
            {stack}
          </pre>
        ) : null}
      </div>
    </div>
  )
}
